import type { DocumentReference } from 'firebase/firestore'
import { collection, getDocs, query, where } from 'firebase/firestore'
import { firestore } from '../firebaseCore'

export const collectionInvoices = collection(
  firestore,
  'collectiveInvoices',
)

export function getInvoicesCollection(company: DocumentReference) {
  return getDocs(query(
    collectionInvoices,
    where(
      'company',
      '==',
      company,
    ),
  ))
}
